export enum CustomEvents {
  TimelineChanged = 'TimelineChanged',
  SpeakersChanged = 'SpeakersChanged',
  AIAgentStatusUpdated = 'AIAgentStatusUpdated',
  OpenContentSettings = 'OpenContentSettings',
  UploadContentDone = 'UploadContentDone',
  OpenSpeakersIdentification = 'OpenSpeakersIdentification',
  ReloadTranscript = 'ReloadTranscript',
  ReloadClip = 'ReloadClip',
  ComputeFrame = 'ComputeFrame',
  ReloadTemplates = 'ReloadTemplates',
  SignOut = 'SignOut',
  TranscriptionStatusUpdated = 'TranscriptionStatusUpdated',
  UploadContentStarted = 'UploadContentStarted',
  ClipGenerationStatusUpdated = 'ClipGenerationStatusUpdated',
  NavigateToContentLabHome = 'NavigateToContentLabHome',
  ReloadAllClips = 'ReloadAllClips',
  OpenEditCaptions = 'OpenEditCaptions',
  ThumbnailGenerated = 'ThumbnailGenerated',
  SocialPostGenerationStatusUpdated = 'SocialPostGenerationStatusUpdated',
  BlogPostGenerationStatusUpdated = 'BlogPostGenerationStatusUpdated',
  EmailPostGenerationStatusUpdated = 'EmailPostGenerationStatusUpdated',
  TakeawayPostGenerationStatusUpdated = 'TakeawayPostGenerationStatusUpdated',
  DownloadTriggerSuccess = 'DownloadTriggerSuccess',
  CloseSharePopup = 'CloseSharePopup',
  OpenCaptionsMenu = 'OpenCaptionsMenu',
  PlaybackRateChange = 'PlaybackRateChange',
  FacialRecognitionStatusUpdated = 'FacialRecognitionStatusUpdated',
  NavigateToContentLabImport = 'NavigateToContentLabImport',
  ClipEnded = 'ClipEnded',
  UpdateChapters = 'UpdateChapters',
  PublishRecordingStatusUpdated = 'PublishRecordingStatusUpdated',
  ChapterGenerationStatusUpdated = 'ChapterGenerationStatusUpdated',
  UpdateCaptionsPosition = 'UpdateCaptionsPosition',
  EditVideoAssetInContentLab = 'EditVideoAssetInContentLab',
  CaptionTranslationStatusUpdated = 'CaptionTranslationStatusUpdated',
  SceneMenuStateChanged = 'SceneMenuStateChanged',
  NewTimelineEntityDraggingStateChanged = 'NewTimelineEntityDraggingStateChanged',
  ReloadCLHomepageMediaContent = 'ReloadCLHomepageMediaContent',
  ZoomValueChangedFromRangeSlider = 'ZoomValueChangedFromRangeSlider',
  SelectionOutlineAction = 'SelectionOutlineAction',
  ClosePromptOverride = 'ClosePromptOverride',
  ClipListPopUp = 'ClipListPopUp',
  TimelineForcedScroll = 'TimelineForcedScroll',
  ReloadSharedPostPage = 'ReloadSharedPostPage',
  FullTranscriptRangeChanged = 'FullTranscriptRangeChanged',
  TimelineDeleteChangeDuringDrag = 'TimelineDeleteChangeDuringDrag',
  OpenCaptionsGallery = 'OpenCaptionsGallery',
  EventMigrationCompleted = 'EventMigrationCompleted',
  OpenAudioOverlayLibraryModal = 'OpenAudioOverlayLibraryModal',
  ClearAiChat = 'ClearAiChat',
  OpenEventMigrationPopup = 'OpenEventMigrationPopup',
  VerticalDragStateChanged = 'VerticalDragStateChanged',
  OpenVideoOverlayLibraryModal = 'OpenVideoOverlayLibraryModal',
  ScreenshareDetectionStatusUpdated = 'ScreenshareDetectionStatusUpdated',
  HomepageCarouselStatusUpdated = 'HomepageCarouselStatusUpdated',
  ChapterAdjustmentNeeded = 'ChapterAdjustmentNeeded',
  CreateClip = 'CreateClip',
  OpenUploadInEditor = 'OpenUploadInEditor',
  OpenTextNavPopup = 'OpenTextNavPopup'
}
